export default "__VITE_ASSET__BkikOYEp__"